<template>
  <div>
    <a id="download" style="display:none"></a>
    <div
      @click="generate_excel">
      <slot>
        <!-- {{button_text}}{{ajaxGetKey}} -->
      </slot>
    </div>
  </div>
</template>

<script>
  import {getTimeDiff, updateTimeByUtc, formatDate} from 'common/js/util'

  export default {
    data () {
      return {
        data: []
      }
    },
    props: {
      name: {
        type: String,
        default: "下載"
      },
      rID: {
        default: ""
      },
      cID: {
        default: ""
      },
      type: {
        default: ""
      },
      keys: {
        default: Array
      },
      ajaxUrl: {
        default: false
      },
      ajaxGetKey: {
        default: false
      },
      ajaxPar: {
        default: {}
      },
      ajaxType: {
        default: "get"
      },
      colData: {
        default: false
      },
      downLoadTran:{
        type: Object,
        default: ()=>{}
      }
    },
    methods: {
      getHeadKeyOrName (type) {
        let arr = []
        this.keys.forEach((item) => {
          if((item.flag === undefined || item.flag) && (item.unneed === undefined || item.unneed)){
            arr.push(item[type])
          }
        })
        return arr
      },
      generate_excel () {
        let curArea = JSON.parse(sessionStorage.getItem('currentArea20'))
        let rID = this.rID ? ' ' + this.rID : ''
        let cID = this.cID ? ' ' + this.cID : ''
        let typeStr = this.type ? ' ' + this.type : ''
        let downLoadName = curArea.group + ' ' + this.name + rID + cID + typeStr

        let ajaxPar = this.ajaxType === "post" ? this.ajaxPar : {params: this.ajaxPar}
        this.$http[this.ajaxType](this.ajaxUrl, ajaxPar).then((res) => {
          let getVal = (obj, arr) => {
            if (arr.length > 1) {
              return getVal(obj[arr[0]], arr.slice(1))
            } else {
              return obj[arr[0]]
            }
          }
          this.data = getVal(res, this.ajaxGetKey)
          this.export2Excel(this.resolveData(this.data), downLoadName)
        })
      },
      export2Excel(excelData, excelName) {
        require.ensure([], () => {
          const { export_json_to_excel } = require('@/vendor/Export2Excel')
          const tHeader = this.getHeadKeyOrName('name')
          const filterVal = this.getHeadKeyOrName('key')
          const list = excelData
          const data = this.formatJson(filterVal, list)
          export_json_to_excel(tHeader, data, excelName)
        })
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
      },
      resolveData(data){
        let arr = []
        if(Array.isArray(data[0])){
          // 后台数据格式[[{},{}],[{},{}]...]
          for(let array of data){
            this.traverse(arr,array)
          }
        }else{
          // 后台数据格式[{},{},{}...]
          this.traverse(arr,data)
        }
        return arr
      },
      traverse(arr,data){
        for(let i in data) {
          let v = data[i]
          let obj = {}
          for(let item of this.keys){
            // 如果头部有flag并且设置了flag为false 或者 有unneed并且设置了unneed为false,则不取值
            if((item.flag !== undefined && !item.flag) || (item.unneed !== undefined && !item.unneed)) continue
            // 头部键需要转大写的转大写取值
            let tempKey = (item.upper=== undefined || item.upper) ? item.key.toUpperCase() : item.key
            // 如果头部有utcTime并且为true,则转换时间格式,时区不变
            if(item.utcTime != undefined && item.utcTime){
              obj[item.key] = v[tempKey] ? formatDate(v[tempKey])  : '';
              continue;
            }
            // 如果头部有changeTime并且为true,则转换对应时区时间
            if(item.changeTime != undefined && item.changeTime){
              obj[item.key] = v[tempKey] ? updateTimeByUtc(getTimeDiff(), v[tempKey])  : ''
              continue
            }
            // 下载翻译对象不存在或者对象不存在此键,则直接取后台返回的值,否则取翻译对象中的值
            if(this.downLoadTran === undefined || !this.downLoadTran[tempKey]){
              obj[item.key] = (v[tempKey] || v[tempKey] == 0) ? v[tempKey] : ''
              continue
            }
            let temp = this.downLoadTran[tempKey][v[tempKey]]
            // 翻译对象通过键取值的对象中有part属性,则给此列数据最后一个做翻译,此列其余数据取后台返回的数据
            if(!this.downLoadTran[tempKey].part){
              obj[item.key] = (temp || temp == 0) ? temp : ""
              continue
            }
            if(i >= data.length - this.downLoadTran[tempKey].index){
              obj[item.key] = (temp || temp == 0) ? temp : ""
              continue
            }
            obj[item.key] = (v[tempKey] || v[tempKey] == 0) ? v[tempKey] : ''
          }
          arr.push(obj)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// excel.vue?67e84d78